import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-side-nav-inner fit" }
const _hoisted_2 = { class: "tw-side-nav-footer" }
const _hoisted_3 = {
  key: 0,
  class: "tw-app-version-wrapper tw-app-version-side-bar w-100"
}
const _hoisted_4 = { class: "d-block font-size-11 text-primary text-right w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_BusinessSelector = _resolveComponent("BusinessSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_scroll_area, { class: "tw-side-nav-scroll" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_list, { class: "tw-side-nav-list" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navItems, (menuItem, index) => {
              return (_openBlock(), _createBlock(_component_NavItem, {
                key: index,
                item: menuItem
              }, null, 8, ["item"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BusinessSelector, { mini: $setup.sidebarMini }, null, 8, ["mini"])
    ]),
    ($options.isUserLogged && $options.isChangePassWord)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.appVersion), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}